import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../services";
import {
  decryptMessage,
  encryptMessage,
  // encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getThresholdData = createAsyncThunk(
  "Threshold/threshold data",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getExistingThresholdData = createAsyncThunk(
  "Threshold/existing threshold data",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const createThreholdValue = createAsyncThunk(
  "Threshold/ create threshold data",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const updateThreholdValue = createAsyncThunk(
  "Threshold/ update threshold data",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, postData)
      .then((res) => {
        const data: any =
          process.env.NODE_ENV === "development"
            ? res.data
            : decryptMessage(JSON.stringify(res.data));
        
        if (data.status === 1) {
          toaster("success", data.message);
        } else {
          toaster("error", data.message);
        }
      })
      .catch((err) => {
        toaster("error", err.message);
        console.error(err);
      });
  }
);
export const deleteThresholdValue = createAsyncThunk(
  "Threshold/delete data",
  ({ endPoint }: { endPoint: String }) => {
    return deleteRequest(endPoint)
      .then((res) => {
        const data: any =
          process.env.NODE_ENV === "development"
            ? res.data
            : decryptMessage(JSON.stringify(res.data));
        toaster("success", data.message);
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  thresholdData: null | "" | Object;
  existingThresholdData: null | "" | Object;
  createdData: null | "" | Boolean;
};

const initialState: SliceState = {
  loading: false,
  thresholdData: "",
  existingThresholdData: "",
  createdData: false,
};

const thresholdItemSlice = createSlice({
  name: "thresholdData",
  initialState,
  reducers: {
    setThresholdHistory(state, action) {
      state.thresholdData = action.payload;
    },
  },
  extraReducers: (builder) => {
    // create data
    builder.addCase(createThreholdValue.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createThreholdValue.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data.status) {
        state.createdData = true;
        toaster("success", data.message);
      } else {
        state.createdData = false;
        toaster("error", data.message);
      }
    });
    builder.addCase(createThreholdValue.rejected, (state) => {
      state.loading = true;
    });
    // get threshold data
    builder.addCase(getThresholdData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getThresholdData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.thresholdData = data?.data;
      } else {
        state.thresholdData = data?.data;
      }
    });
    builder.addCase(getThresholdData.rejected, (state) => {
      state.loading = true;
    });
    // get threshold data by project
    builder.addCase(getExistingThresholdData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExistingThresholdData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.existingThresholdData = data?.data;
      } else {
        state.existingThresholdData = [];
      }
    });
    builder.addCase(getExistingThresholdData.rejected, (state) => {
      state.loading = true;
    });
  },
});

export const { setThresholdHistory } = thresholdItemSlice.actions;

export default thresholdItemSlice;
